import clsx from 'clsx'

import MBonusIcon from 'shared/icons/mbonus.svg'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

type Props = {
  text: string
  onClick?: () => void
}

export const MBonusIcons = ({ text, onClick }: Props) => {
  return (
    <div
      className={s.wrapper}
      onClick={onClick}
    >
      <ImageLazy
        src={MBonusIcon}
        alt=""
        className={s.icon}
      />
      <p className={clsx(s.cashback, 'semi-bold-11')}>{text}</p>
    </div>
  )
}
